<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="d-flex align-center justify-space-between">
        <h2>Report utenti</h2>
      </v-col>
      <v-col cols="12">
        <v-divider />
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-autocomplete  v-model="query.user" label="Utente"  :items="userOptions" clearable></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-text-field  v-model="query.from" label="Ricevuti dal" type="date" clearable></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-select  v-model="query.to" label="Ricevuti fino al" type="date" clearable></v-select>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <data-table :headers="headers" collection="reports" :editable="false" viewable view-sub-path="" :deletable="isAdmin" :query="query" @error="onListError" :default-sort="{key:'date', order:'desc'}">
          <template v-slot:item.user.surname="{ item }">
            <a class="text-decoration-underline cursor-pointer text-primary" @click="$router.push(`/reports/${item._id}`)"><b>{{ item.user.surname }}</b> {{ item.user.name }}</a>
          </template>
          <template #item.date="{item}">
            {{ formatDateTime(item.date)}}
          </template>
        </data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import {defineComponent, ref, computed, watch, onMounted, inject, onBeforeUnmount} from 'vue'
import { useRouter } from 'vue-router'
import utils from '../utils'
import DataTable from "@/components/DataTable.vue";
import {type DataTableError, type Query, UserRole} from "@/models.ts";
import {type Messages, Msg} from "@/plugins/messages.ts";
import {roles} from "@/consts.ts";
import type {Auth} from "@/plugins/auth.ts";
import type {Globals} from "@/plugins/globals.ts";

export default defineComponent({
  name: "UserList",
  components: {DataTable},
  setup() {
    const auth = inject('auth') as Auth
    const messages = inject('messages') as Messages
    const globals = inject('globals') as Globals

    const query = ref<Query>({})

    let wh:any;
    onMounted(async ()=>{
      await auth.waitForLogin
      await globals.refresh('users')

      query.value = utils.getSessionQuery(`reports`)
      wh = watch(query.value, ()=>{
        utils.setSessionQuery("reports", query.value)
      }, { deep: true })
    })
    onBeforeUnmount(()=>{
      if(wh) wh();
    })
    return {
      isAdmin : auth.isAdmin,
      UserRole,
      roles,
      formatDateTime : utils.formatDateTime,
      query,
      userOptions : computed(()=>{
        return globals.users.value.map(u => {
          return {
            title : `${u.name} ${u.surname} (${u.email})`,
            value : u._id
          }
        })
      }),
      headers : [
        { title : 'Cognome e nome', sortable: true, align: 'left', value : 'user.surname' },
        { title : 'Data', sortable: true, align: 'left', value : 'date' },
        { title : 'Pacchetto', sortable: true, align: 'left', value : 'kit.title.it' },
        { title : 'Prodotto', sortable: true, align: 'left', value : 'product.title.it' },
        { title : 'Lezione', sortable: true, align: 'left', value : 'lesson.title.it' },
      ],
      onListError(e:DataTableError) {
        if(e.status === 401) {
          messages.error(Msg.permissionError)
          auth.logout()
          return
        }
        messages.error(`Errore: ${e.message}`)
      },
    }
  }
})
</script>
